// extracted by mini-css-extract-plugin
export default {"notificationList":"styles_notification-list__YNZh6","notificationList__placeholder":"styles_notification-list__placeholder__hzrRm"};